export default "__VITE_ASSET__BlLqRxZA__"